<template>
  <div class="container">
    <div v-if="movies == null">
      loading
    </div>
    <div v-else>
      <!-- aa {{movies}} -->
      <movie-item-horizontal-component v-for="movie in movies.data" :movie="movie" :key="movie.slug"></movie-item-horizontal-component>
      <paginate-component v-bind="movies"></paginate-component>
    </div>
  </div>
</template>
<script>
export default {
  name: 'feed-trending',
  data() {
    return {
      movies: null,
    }
  },
  created() {
    window.api.trending.index(this.$route.query, (movies) => this.movies = movies);
  }
}

</script>
